import { render, staticRenderFns } from "./strategy-tpl-use-modal.vue?vue&type=template&id=64a92b0a&scoped=true&"
import script from "./strategy-tpl-use-modal.vue?vue&type=script&lang=js&"
export * from "./strategy-tpl-use-modal.vue?vue&type=script&lang=js&"
import style0 from "./strategy-tpl-use-modal.vue?vue&type=style&index=0&id=64a92b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a92b0a",
  null
  
)

export default component.exports